import React from "react";
import {DefaultAvatar} from "../../../../components/common/DefaultAvatar";

export const PersonalDataHeader = ({
                                       name,
                                       color,
                                   }: {
    name: string;
    color?: string;
}) => {
    return (
        <div className="flex items-center p-6">
            <DefaultAvatar name={name} color={color} height={72} width={72} />
            <div className="ml-4">
                <div className="text-xl font-semibold">{name}</div>
            </div>
        </div>
    );
};
